module.exports = __webpack_public_path__ + "img/security.0190fb43.svg";